import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { CHART_BRUSH_SIZES } from '../../consts/chart-brush';
import { CHART_THEME_MODE } from './const';
import { CHART_THEMES } from './themes';

export const chartElementsSx = (theme: Theme): SystemStyleObject<Theme> => {
  const { palette } = CHART_THEMES[theme.palette.mode === 'dark' ? CHART_THEME_MODE.DARK : CHART_THEME_MODE.LIGHT];

  return {
    '& .recharts-cartesian-axis-tick-value, & .recharts-cartesian-axis-tick-label, & .recharts-label': {
      ...theme.typography.caption,
      fill: palette.general.labels,
      color: palette.general.labels,
    },
    '& .recharts-cartesian-axis-line': {
      stroke: palette.general.axis,
      strokeWidth: 1,
    },
    '& .recharts-cartesian-grid line': {
      stroke: palette.general.grid,
    },
    '& .recharts-brush > rect': {
      fill: `${palette.general.fillBackground}!important`,
      stroke: 'transparent!important',
    },
    '& .recharts-brush rect.recharts-brush-slide': {
      fill: `${palette.general.grid}!important`,
      stroke: 'transparent!important',
      rx: 10,
    },
    '& .recharts-brush rect': {
      fill: `${palette.general.fillBackground}!important`,
      '&.recharts-brush-slide': {
        fill: `${palette.general.scrollBar}!important`,
        stroke: `${palette.general.fillBackground}!important`,
        strokeWidth: `${CHART_BRUSH_SIZES.BRUSH_STROKE_WIDTH} !important`,
        fillOpacity: '1 !important',
      },
    },
    '& .recharts-brush-traveller, & .recharts-brush-texts': {
      display: 'none',
    },
  };
};
